import { AsyncPipe } from '@angular/common';
import { Component, inject } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { AwareAuthIdleService, AwareAuthLogoutReason, AwareAuthService } from '@appbolaget/aware-auth';

@Component({
    selector: 'app-aware-auth-idle-warning',
    templateUrl: 'idle-warning.component.html',
    imports: [MatDialogModule, AsyncPipe, MatButtonModule],
})
export class AwareAuthIdleWarningComponent {
    dialogRef = inject<MatDialogRef<AwareAuthIdleWarningComponent>>(MatDialogRef);

    #awareAuth = inject(AwareAuthService);
    #awareIdleService = inject(AwareAuthIdleService);

    durationRemaining$ = this.#awareIdleService.timeoutTimerDuration$();

    stayLoggedIn() {
        this.#awareIdleService.resetTimer();
        this.dialogRef.close();
    }

    logout() {
        this.#awareIdleService.resetTimer();
        this.#awareAuth.logout({
            reason: AwareAuthLogoutReason.manual,
        });
        this.dialogRef.close();
    }
}
